import mYoya from "./yoya.svg";
import mLogo from "./logos/logo.svg";
import tab from "./tab.svg";
import rectangles from "./design/rectangles.svg";

export const YoyaSVG = mYoya;
export const LogoSVG = mLogo;
export const TabSVG = tab;
export const LogoHorizontalSVG = mLogo;

// DESIGN
export const RectanglesSVG = rectangles;
